//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './WarrantyRequestBasketClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetWarrantyRequestBasketQueryParameters = {
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type SendWarrantyRequestWarrantyRequestBasketQueryParameters = {
  additionalEmail?: string | null | undefined ;
  reference?: string | null | undefined ;
}

export type GetCertainOrderWarrantyRequestBasketQueryParameters = {
  itemNumber?: string | undefined ;
  language?: string | undefined ;
}


export type SearchLastAddedDeviceWarrantyRequestBasketQueryParameters = {
  serviceProduct?: string | undefined ;
}

export function getUrl(offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/warranty-request/basket?";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.BasketGetResponseDto, unknown, Types.BasketGetResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.BasketGetResponseDto, unknown, Types.BasketGetResponseDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetWarrantyRequestBasketQueryParameters): QueryKey;
export function getQueryKey(offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { offset, limit, sortBy, sortOrder,  } = params[0] as GetWarrantyRequestBasketQueryParameters;

    return trimArrayEnd([
        'WarrantyRequestBasketClient',
        'get',
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'WarrantyRequestBasketClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as string | null | undefined,       context.queryKey[5] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.BasketGetResponseDto, TError = unknown>(dto: GetWarrantyRequestBasketQueryParameters, options?: Omit<UseQueryOptions<Types.BasketGetResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get basket
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetQuery<TSelectData = Types.BasketGetResponseDto, TError = unknown>(offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.BasketGetResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.BasketGetResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.BasketGetResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ offset, limit, sortBy, sortOrder,  } = params[0] as GetWarrantyRequestBasketQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.BasketGetResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(offset, limit, sortBy, sortOrder),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.BasketGetResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get basket
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.BasketGetResponseDto | undefined) => Types.BasketGetResponseDto, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getQueryKey(offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Get basket
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.BasketGetResponseDto | undefined) => Types.BasketGetResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function sendWarrantyRequestUrl(additionalEmail?: string | null | undefined, reference?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/warranty-request/basket?";
if (additionalEmail !== undefined && additionalEmail !== null)
    url_ += "AdditionalEmail=" + encodeURIComponent("" + additionalEmail) + "&";
if (reference !== undefined && reference !== null)
    url_ += "Reference=" + encodeURIComponent("" + reference) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendWarrantyRequestMutationKey(additionalEmail?: string | null | undefined, reference?: string | null | undefined): MutationKey {
  return trimArrayEnd([
      'WarrantyRequestBasketClient',
      'sendWarrantyRequest',
      additionalEmail as any,
      reference as any,
    ]);
}

/**
 * Send warranty request
 * @param additionalEmail (optional) Additional email-adress (mailzusatz)
 * @param reference (optional) Reference (kundenref)
 */
export function useSendWarrantyRequestMutation<TContext>(additionalEmail?: string | null | undefined, reference?: string | null | undefined, options?: Omit<UseMutationOptions<string, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, void, TContext> {
  const key = sendWarrantyRequestMutationKey(additionalEmail, reference);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.sendWarrantyRequest(additionalEmail, reference),
    mutationKey: key,
  });
}
  
type SendWarrantyRequest__MutationParameters = SendWarrantyRequestWarrantyRequestBasketQueryParameters

/**
 * Send warranty request
 * @param additionalEmail (optional) Additional email-adress (mailzusatz)
 * @param reference (optional) Reference (kundenref)
 */
export function useSendWarrantyRequestMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<string, unknown, SendWarrantyRequest__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendWarrantyRequestWarrantyRequestBasketQueryParameters}): UseMutationResult<string, unknown, SendWarrantyRequest__MutationParameters, TContext> {
  const key = sendWarrantyRequestMutationKey(options?.parameters?.additionalEmail!, options?.parameters?.reference!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendWarrantyRequest__MutationParameters) => Client.sendWarrantyRequest(data.additionalEmail ?? options?.parameters?.additionalEmail!, data.reference ?? options?.parameters?.reference!),
  mutationKey: key,
});
}
  
export function getCertainOrderUrl(itemNumber?: string | undefined, language?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/warranty-request/basket/order?";
if (itemNumber === null)
    throw new Error("The parameter 'itemNumber' cannot be null.");
else if (itemNumber !== undefined)
    url_ += "ItemNumber=" + encodeURIComponent("" + itemNumber) + "&";
if (language === null)
    throw new Error("The parameter 'language' cannot be null.");
else if (language !== undefined)
    url_ += "language=" + encodeURIComponent("" + language) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getCertainOrderDefaultOptions: Omit<UseQueryOptions<Types.BasketCertainOrderResponseDto, unknown, Types.BasketCertainOrderResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.BasketCertainOrderResponseDto, unknown, Types.BasketCertainOrderResponseDto>, 'queryFn'>> = {
};
export function getGetCertainOrderDefaultOptions() {
  return getCertainOrderDefaultOptions;
};
export function setGetCertainOrderDefaultOptions(options: typeof getCertainOrderDefaultOptions) {
  getCertainOrderDefaultOptions = options;
}

export function getCertainOrderQueryKey(dto: GetCertainOrderWarrantyRequestBasketQueryParameters): QueryKey;
export function getCertainOrderQueryKey(itemNumber?: string | undefined, language?: string | undefined): QueryKey;
export function getCertainOrderQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { itemNumber, language,  } = params[0] as GetCertainOrderWarrantyRequestBasketQueryParameters;

    return trimArrayEnd([
        'WarrantyRequestBasketClient',
        'getCertainOrder',
        itemNumber as any,
        language as any,
      ]);
  } else {
    return trimArrayEnd([
        'WarrantyRequestBasketClient',
        'getCertainOrder',
        ...params
      ]);
  }
}
export function __getCertainOrder(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getCertainOrder(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,axiosConfig    );
}

export function useGetCertainOrderQuery<TSelectData = Types.BasketCertainOrderResponseDto, TError = unknown>(dto: GetCertainOrderWarrantyRequestBasketQueryParameters, options?: Omit<UseQueryOptions<Types.BasketCertainOrderResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get certain order
 * @param itemNumber (optional) Number of the certain order item (epos)
 * @param language (optional) 
 */
export function useGetCertainOrderQuery<TSelectData = Types.BasketCertainOrderResponseDto, TError = unknown>(itemNumber?: string | undefined, language?: string | undefined, options?: Omit<UseQueryOptions<Types.BasketCertainOrderResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetCertainOrderQuery<TSelectData = Types.BasketCertainOrderResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.BasketCertainOrderResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let itemNumber: any = undefined;
  let language: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ itemNumber, language,  } = params[0] as GetCertainOrderWarrantyRequestBasketQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [itemNumber, language, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.BasketCertainOrderResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getCertainOrder(context, axiosConfig) : __getCertainOrder,
    queryKey: getCertainOrderQueryKey(itemNumber, language),
    ...getCertainOrderDefaultOptions as unknown as Omit<UseQueryOptions<Types.BasketCertainOrderResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get certain order
 * @param itemNumber (optional) Number of the certain order item (epos)
 * @param language (optional) 
 */
export function setGetCertainOrderData(queryClient: QueryClient, updater: (data: Types.BasketCertainOrderResponseDto | undefined) => Types.BasketCertainOrderResponseDto, itemNumber?: string | undefined, language?: string | undefined) {
  queryClient.setQueryData(getCertainOrderQueryKey(itemNumber, language),
    updater
  );
}

/**
 * Get certain order
 * @param itemNumber (optional) Number of the certain order item (epos)
 * @param language (optional) 
 */
export function setGetCertainOrderDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.BasketCertainOrderResponseDto | undefined) => Types.BasketCertainOrderResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchOrderUrl(): string {
  let url_ = getBaseUrl() + "/api/warranty-request/basket/order";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchOrderMutationKey(): MutationKey {
  return trimArrayEnd([
      'WarrantyRequestBasketClient',
      'patchOrder',
    ]);
}

/**
 * Edit order
 */
export function usePatchOrderMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.BasketPatchOrderDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.BasketPatchOrderDto, TContext> {
  const key = patchOrderMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (request: Types.BasketPatchOrderDto) => Client.patchOrder(request),
    mutationKey: key,
  });
}
  
export function patchOrderStatusUrl(): string {
  let url_ = getBaseUrl() + "/api/warranty-request/basket/order/status";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchOrderStatusMutationKey(): MutationKey {
  return trimArrayEnd([
      'WarrantyRequestBasketClient',
      'patchOrderStatus',
    ]);
}

/**
 * Change order's alive status (stored status)
 */
export function usePatchOrderStatusMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.BasketPatchOrderStatusDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.BasketPatchOrderStatusDto, TContext> {
  const key = patchOrderStatusMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (request: Types.BasketPatchOrderStatusDto) => Client.patchOrderStatus(request),
    mutationKey: key,
  });
}
  
export function clearBasketUrl(): string {
  let url_ = getBaseUrl() + "/api/warranty-request/basket/clear";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function clearBasketMutationKey(): MutationKey {
  return trimArrayEnd([
      'WarrantyRequestBasketClient',
      'clearBasket',
    ]);
}

/**
 * Clear all orders from the basket
 */
export function useClearBasketMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = clearBasketMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.clearBasket(),
    mutationKey: key,
  });
}
  
export function searchLastAddedDeviceUrl(serviceProduct?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/warranty-request/basket/same-device?";
if (serviceProduct === null)
    throw new Error("The parameter 'serviceProduct' cannot be null.");
else if (serviceProduct !== undefined)
    url_ += "ServiceProduct=" + encodeURIComponent("" + serviceProduct) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchLastAddedDeviceDefaultOptions: Omit<UseQueryOptions<Types.SameDeviceResponseDto, unknown, Types.SameDeviceResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SameDeviceResponseDto, unknown, Types.SameDeviceResponseDto>, 'queryFn'>> = {
};
export function getSearchLastAddedDeviceDefaultOptions() {
  return searchLastAddedDeviceDefaultOptions;
};
export function setSearchLastAddedDeviceDefaultOptions(options: typeof searchLastAddedDeviceDefaultOptions) {
  searchLastAddedDeviceDefaultOptions = options;
}

export function searchLastAddedDeviceQueryKey(serviceProduct?: string | undefined): QueryKey;
export function searchLastAddedDeviceQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { serviceProduct,  } = params[0] as SearchLastAddedDeviceWarrantyRequestBasketQueryParameters;

    return trimArrayEnd([
        'WarrantyRequestBasketClient',
        'searchLastAddedDevice',
        serviceProduct as any,
      ]);
  } else {
    return trimArrayEnd([
        'WarrantyRequestBasketClient',
        'searchLastAddedDevice',
        ...params
      ]);
  }
}
export function __searchLastAddedDevice(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.searchLastAddedDevice(
      context.queryKey[2] as string | undefined,axiosConfig    );
}

export function useSearchLastAddedDeviceQuery<TSelectData = Types.SameDeviceResponseDto, TError = unknown>(dto: SearchLastAddedDeviceWarrantyRequestBasketQueryParameters, options?: Omit<UseQueryOptions<Types.SameDeviceResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get last added device with same service product id
 * @param serviceProduct (optional) Service product (serviceprodukt)
 */
export function useSearchLastAddedDeviceQuery<TSelectData = Types.SameDeviceResponseDto, TError = unknown>(serviceProduct?: string | undefined, options?: Omit<UseQueryOptions<Types.SameDeviceResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchLastAddedDeviceQuery<TSelectData = Types.SameDeviceResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SameDeviceResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let serviceProduct: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ serviceProduct,  } = params[0] as SearchLastAddedDeviceWarrantyRequestBasketQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [serviceProduct, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SameDeviceResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __searchLastAddedDevice(context, axiosConfig) : __searchLastAddedDevice,
    queryKey: searchLastAddedDeviceQueryKey(serviceProduct),
    ...searchLastAddedDeviceDefaultOptions as unknown as Omit<UseQueryOptions<Types.SameDeviceResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get last added device with same service product id
 * @param serviceProduct (optional) Service product (serviceprodukt)
 */
export function setSearchLastAddedDeviceData(queryClient: QueryClient, updater: (data: Types.SameDeviceResponseDto | undefined) => Types.SameDeviceResponseDto, serviceProduct?: string | undefined) {
  queryClient.setQueryData(searchLastAddedDeviceQueryKey(serviceProduct),
    updater
  );
}

/**
 * Get last added device with same service product id
 * @param serviceProduct (optional) Service product (serviceprodukt)
 */
export function setSearchLastAddedDeviceDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SameDeviceResponseDto | undefined) => Types.SameDeviceResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}